<template>
    <q-dialog
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        persistent
    >
        <q-card style="max-width: 90vw">
            <q-toolbar class="bg-primary text-white q-mb-md">
                <q-toolbar-title>Agregar Cliente</q-toolbar-title>
                <q-space />
                <q-btn dense flat icon="close" v-close-popup>
                    <q-tooltip>Cerrar</q-tooltip>
                </q-btn>
            </q-toolbar>
            <q-card-section style="max-height: 90vh" class="scroll col">
                <form @submit.prevent="validate">
                    <div class="row q-gutter-x-md">
                        <div class="col">
                            <GltnInput
                                label="Razón social"
                                v-model="input.A1_NOME"
                                name="A1_NOME"
                                @update:modelValue="validate($event, 'A1_NOME')"
                                :errors="res.getErrors('A1_NOME')"
                            />
                        </div>
                        <div class="col">
                            <GltnInput
                                label="Dirección"
                                v-model="input.A1_END"
                                name="A1_END"
                                @update:modelValue="validate($event, 'A1_END')"
                                :errors="res.getErrors('A1_END')"
                            />
                        </div>
                    </div>
                    <div class="row q-gutter-x-md">
                        <div class="col">
                            <GltnSelectTipoCliente
                                label="Tipo de cliente"
                                v-model="input.A1_TIPO"
                                name="A1_TIPO"
                                @update:modelValue="validate($event, 'A1_TIPO')"
                                :errors="res.getErrors('A1_TIPO')"
                            />
                        </div>
                        <div class="col">
                            <GltnInput
                                label="CUIT"
                                v-model="input.A1_CGC"
                                name="A1_CGC"
                                @update:modelValue="validate($event, 'A1_CGC')"
                                :errors="res.getErrors('A1_CGC')"
                            />
                        </div>
                    </div>
                    <div class="row q-gutter-x-md">
                        <div class="col">
                            <GltnInput
                                label="Nombre de Fantasía"
                                v-model="input.A1_NREDUZ"
                                name="A1_NREDUZ"
                                @update:modelValue="
                                    validate($event, 'A1_NREDUZ')
                                "
                                :errors="res.getErrors('A1_NREDUZ')"
                            />
                        </div>
                        <div class="col">
                            <GltnSelectVendedores
                                label="Vendedor"
                                v-model="input.A1_VEND"
                                name="A1_VEND"
                                @update:modelValue="validate($event, 'A1_VEND')"
                                :errors="res.getErrors('A1_VEND')"
                            />
                        </div>
                        <div class="col">
                            <GltnInput
                                label="Municipio"
                                v-model="input.A1_MUN"
                                name="A1_MUN"
                                @update:modelValue="validate($event, 'A1_MUN')"
                                :errors="res.getErrors('A1_MUN')"
                            />
                        </div>
                    </div>
                    <div class="row q-gutter-x-md">
                        <div class="col">
                            <GltnSelectProvincias
                                label="Provincia"
                                v-model="input.A1_EST"
                                name="A1_EST"
                                @update:modelValue="validate($event, 'A1_EST')"
                                :errors="res.getErrors('A1_EST')"
                            />
                        </div>
                        <div class="col">
                            <GltnInput
                                label="Código Postal"
                                v-model="input.A1_CEP"
                                name="A1_CEP"
                                @update:modelValue="validate($event, 'A1_CEP')"
                                :errors="res.getErrors('A1_CEP')"
                            />
                        </div>
                        <div class="col">
                            <GltnSelectPais
                                label="País"
                                v-model="input.A1_PAIS"
                                name="A1_PAIS"
                                @update:modelValue="validate($event, 'A1_PAIS')"
                                :errors="res.getErrors('A1_PAIS')"
                            />
                        </div>
                        <div class="col">
                            <GltnInput
                                label="Teléfono"
                                v-model="input.A1_TEL"
                                name="A1_TEL"
                                @update:modelValue="validate($event, 'A1_TEL')"
                                :errors="res.getErrors('A1_TEL')"
                            />
                        </div>
                        <div class="col">
                            <GltnInput
                                label="Email"
                                v-model="input.A1_EMAIL"
                                name="A1_EMAIL"
                                @update:modelValue="
                                    validate($event, 'A1_EMAIL')
                                "
                                :errors="res.getErrors('A1_EMAIL')"
                            />
                        </div>
                    </div>
                    <div class="row q-gutter-x-md">
                        <div class="col">
                            <GltnInput
                                label="Contacto comercial"
                                v-model="input.A1_XCONCOM"
                                name="A1_XCONCOM"
                                @update:modelValue="
                                    validate($event, 'A1_XCONCOM')
                                "
                                :errors="res.getErrors('A1_XCONCOM')"
                            />
                        </div>
                        <!-- <div class="col">
                            <GltnInput
                                label="Telefono Contacto comercial"
                                v-model="input.A1_XTELCOM"
                                name="A1_XTELCOM"
                                @update:modelValue="
                                    validate($event, 'A1_XTELCOM')
                                "
                                :errors="res.getErrors('A1_XTELCOM')"
                            />
                        </div>
                        <div class="col">
                            <GltnInput
                                label="Email Contacto comercial"
                                v-model="input.A1_XEMAILC"
                                name="A1_XEMAILC"
                                @update:modelValue="
                                    validate($event, 'A1_XEMAILC')
                                "
                                :errors="res.getErrors('A1_XEMAILC')"
                            />
                        </div> -->
                    </div>
                </form>
            </q-card-section>
            <q-separator />
            <q-card-actions align="right">
                <q-btn flat label="Cancelar" color="red" v-close-popup />
                <q-btn
                    flat
                    label="Guardar"
                    color="primary"
                    @click="store"
                    :disable="!res.valid"
                />
            </q-card-actions>
            <q-inner-loading :showing="loading">
                <q-spinner-hourglass size="50px" color="primary" />
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<script setup>
import ClienteService from "@/services/ClienteService.js";
import GltnInput from "@/components/form/GltnInput.vue";
import GltnSelectPais from "@/components/form/GltnSelectPais.vue";
import GltnSelectProvincias from "@/components/form/GltnSelectProvincias.vue";
import GltnSelectTipoCliente from "@/components/form/GltnSelectTipoCliente.vue";
import GltnSelectVendedores from "@/components/form/GltnSelectVendedores.vue";
import suite from "./ClienteCrudValidation.js";
import { reactive, ref, onMounted } from "vue";
import { useQuasar } from "quasar";

const $q = useQuasar();
const loading = ref(false);
const res = ref();
res.value = suite.get();
const validate = (value, name) => {
    res.value = suite(name, input);
};
onMounted(async () => {
    validate();
});
const props = defineProps({
    oper: [String],
    modelValue: {
        type: Boolean,
        default: false,
    },
    id: {
        type: [String, Number],
        default: null,
    },
});
const emits = defineEmits(["update:modelValue", "updated"]);
const input = reactive({
    A1_NOME: "",
    A1_END: "",
    A1_TIPO: "",
    A1_CGC: "",
    A1_NREDUZ: "",
    A1_VEND: "",
    A1_MUN: "",
    A1_EST: "",
    A1_CEP: "",
    A1_PAIS: "063",
    A1_TEL: "",
    A1_EMAIL: "",
    A1_AFIP: "1",
    A1_CONTA: "11210001",
    A1_NATUREZ: "",
    A1_XCONCOM: "",
    A1_XTELCOM: "",
    A1_XEMAILC: "",
});

const store = async () => {
    try {
        loading.value = true;
        const response = await ClienteService.store({
            ...input,
            A1_VEND: input.A1_VEND.value || null,
        });
        if(response?.result?.cliente) {
            emits("updated", response.result.cliente);
        }

        emits("update:modelValue", false);

        res.value = suite.get(); // Reset validation state
        Object.keys(input).forEach((key) => {
            input[key] = ""; // Clear input fields
        });
        input.A1_AFIP = "1";
        input.A1_CONTA = "11210001";
        input.A1_PAIS = "063";
    } catch (error) {
        console.error("Error al guardar el cliente:", error);
    } finally {
        loading.value = false;
    }
};
</script>
